import { render, staticRenderFns } from "./studentTrain.vue?vue&type=template&id=cae272e6&scoped=true"
import script from "./studentTrain.vue?vue&type=script&lang=js"
export * from "./studentTrain.vue?vue&type=script&lang=js"
import style0 from "./studentTrain.vue?vue&type=style&index=0&id=cae272e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae272e6",
  null
  
)

export default component.exports